<template>
   <v-container class="d-flex align-center justify-center" style="height: 100vh;">
     <v-card width="600px" class="pa-5 d-flex flex-column justify-center align-center">
      <v-card-title class="text-center indigo--text">Sign In With Email</v-card-title>
        <v-card-subtitle class="text-center "> log in to Access the best deals and smooth bookings here </v-card-subtitle>
        <div class="mt-n2 d-flex align-center">
                  Don't have an account?
                  <v-btn text color="indigo" class="ml-n3" to="/register">Register now</v-btn>
                </div>
        <v-card-text>
            <v-form ref="loginForm" v-model="validLoginForm">
                <v-text-field
                  v-model="email"
                  label="Email"
                  outlined
                  clearable
                  color="indigo"
                  :rules="[rules.required, rules.email]"
                />
                <v-text-field
                  v-model="password"
                  label="password"
                  outlined
                  color="indigo"
                  :rules="[rules.required]"
                  :type="show ? 'text' : 'password'"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show = !show"
                />
                <v-btn text  color="indigo" class="mb-5 mt-n7" @click="preForgetPasswordDialog = true">Forgot Your Password?</v-btn>
                <v-dialog max-width="600" v-model="preForgetPasswordDialog" persistent>
                  <v-card class="pa-3">
                    <v-card-title class="indigo--text">Forget your password?</v-card-title>
                    <v-card-text>
                      <p>We’ll send a code to your email to reset your password</p>
                     <v-form ref="resetForm" v-model="validResetForm" class="mt-3">
                       <v-text-field
                        v-model="resetEmail"
                        label="Email"
                        outlined
                        clearable
                        color="indigo"
                        :rules="[rules.required, rules.email]"
                      />
                     </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn color="warning" @click="preForgetPasswordDialog =false">Close</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="indigo" class="white--text" @click="getResetCode" :loading="loading">send</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog max-width="600" v-model="forgetPasswordDialog" persistent>
                  <v-card class="pa-3">
                    <v-card-title class="indigo--text">Reset Your Password</v-card-title>
                    <v-card-text>
                      <p>Please enter the verification code sent to your email, then set your new password</p>
                     <v-form ref="resetPasswordForm" v-model="validResetCodeForm" class="mt-3">
                       <v-text-field
                        v-model="confirmEmail"
                        label="Email"
                        outlined
                        clearable
                        color="indigo"
                        :rules="[rules.required, rules.email]"
                      />
                      <v-text-field
                        v-model="confirmPassword"
                        label="new password"
                        outlined
                        color="indigo"
                        :rules="[rules.required]"
                        :type="show ? 'text' : 'password'"
                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="show = !show"
                />
                <v-text-field
                        v-model="password_confirmation"
                        label="confirm password"
                        outlined
                        color="indigo"
                        :rules="[rules.required, rules.confirm]"
                        :type="showConfirm ? 'text' : 'password'"
                        :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showConfirm = !showConfirm"
                />
                       <v-text-field
                        v-model="confirmCode"
                        label="Code"
                        outlined
                        clearable
                        color="indigo"
                        :rules="[rules.required]"
                      />
                     </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn color="warning" @click="forgetPasswordDialog =false">Close</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="indigo" class="white--text" @click="resetPassword" :loading="loading">send</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-btn block color="indigo" class="white--text" @click="login" :loading="loading">Login</v-btn>
            </v-form>
        </v-card-text>
     </v-card>
   </v-container>
</template>
<script>
// import { getUser } from '../links'
import { headersNoAuth, login, resetPassword, resetPasswordCode } from '.././links'
export default {
  data () {
    return {
      validLoginForm: true,
      validResetForm: true,
      validResetCodeForm: true,
      preForgetPasswordDialog: false,
      forgetPasswordDialog: false,
      loading: false,
      email: null,
      resetEmail: null,
      confirmEmail: null,
      password_confirmation: null,
      confirmCode: null,
      confirmPassword: null,
      text: null,
      color: null,
      show: false,
      showConfirm: false,
      password: null,
      rules: {
        required: value => !!value || 'this field is required',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail'
        },
        confirm: value => value === this.confirmPassword || 'Passwords must be the same'
      }
    }
  },
  methods: {
    login () {
      console.log('test', login)
      this.$refs.loginForm.validate()
      if (this.validLoginForm) {
        this.loading = true
        const body = {
          password: this.password,
          email: this.email
        }
        const header = { headers: headersNoAuth() }
        this.$http.post(login, body, header)
          .then(response => {
            this.loading = false
            if (response.data.data) {
              if (response.data.data.user.active || response.data.data.user.role === 'superAdmin') {
                this.$store.commit('showFeedback', { text: response.data.message, color: 'success' })
                this.$store.commit('setUserId', response.data.data.user.id)
                this.$store.commit('setUser', response.data.data.token.access_token)
                localStorage.setItem('BVtoken', response.data.data.token.access_token)
                this.$store.commit('setUserData', response.data.data.user)
                this.$router.push('/')
              } else {
                this.$router.push('/confirm')
                this.$store.commit('showFeedback', { text: ' once you get a verification email u can login and book ticket', color: 'success' })
              }
              // localStorage.setItem('token', response.data.data.token.access_token)
            } else {
              this.$store.commit('showFeedback', { text: response.data.message, color: 'error' })
            }
          })
          .catch(err => {
            console.error(err)
            this.$store.commit('showFeedback', { text: err.body.message, color: 'error' })
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    getResetCode () {
      this.$refs.resetForm.validate()
      if (this.validResetForm) {
        this.loading = true
        const header = { headers: headersNoAuth() }
        const body = {
          email: this.resetEmail
        }
        this.$http.post(resetPasswordCode, body, header)
          .then(response => {
            this.$store.commit('showFeedback', { text: response.data.message, color: 'success' })
            this.preForgetPasswordDialog = false
            this.forgetPasswordDialog = true
          })
          .catch(err => {
            console.error(err)
            this.$store.commit('showFeedback', { text: 'Something went wrong', color: 'error' })
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    resetPassword () {
      this.$refs.resetPasswordForm.validate()
      if (this.validResetCodeForm) {
        this.loading = true
        const header = { headers: headersNoAuth() }
        const body = {
          email: this.confirmEmail,
          code: this.confirmCode,
          password: this.confirmPassword,
          password_confirmation: this.password_confirmation
        }
        this.$http.post(resetPassword, body, header)
          .then(response => {
            this.$store.commit('showFeedback', { text: response.data.message, color: 'success' })
            this.forgetPasswordDialog = false
          })
          .catch(err => {
            console.error(err)
            this.$store.commit('showFeedback', { text: 'Something went wrong', color: 'error' })
          })
          .finally(() => {
            this.loading = false
          })
      }
    }

  }
}
</script>
